import { LogOut } from "./Token.helper";
const getAvailabilityPerMentor = async () => {

    const availability = await fetch(`/api/availability`, {
        method: 'GET',
        headers: {
            'accept': '*/*'
        }
    });
    if(!availability.ok){
        if(availability.status == 401){
            LogOut();
        }
        throw new Error;
    }

    const body = await availability.json();

    console.log(body);

    return body;
}

const createAvailabilityPerMentor = async (data) => {
    console.log(data);
    await fetch(`/api/availability`, {
        method: 'PUT',
        headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

}

const deleteAvailabilityPerMentor = async (data) => {
    console.log(data);
    await fetch(`/api/availability?id=${data}`, {
        method: 'DELETE',
        headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
        }
    });

}

const updateAvailabilityPerMentor = async (data) => {
    console.log(data);
    await fetch(`/api/availability`, {
        method: 'POST',
        headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

}


export {
    getAvailabilityPerMentor,
    createAvailabilityPerMentor,
    deleteAvailabilityPerMentor,
    updateAvailabilityPerMentor
}
